export const quarterlyTradesReportLocation = "/reports/sec/quarterlyreports"